import { render, staticRenderFns } from "./vendas.vue?vue&type=template&id=9ae95fba"
import script from "./vendas.vue?vue&type=script&lang=js"
export * from "./vendas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports